import { render, staticRenderFns } from "./table-tag.vue?vue&type=template&id=1fc05986"
import script from "./table-tag.vue?vue&type=script&lang=js"
export * from "./table-tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports